import styled from 'styled-components';
import { IThemeProvider } from '../../../../../../styles/theme';

export const Wrapper = styled.div`
  width: 40px;
  height: 18px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  ${({ theme }: IThemeProvider) => `
    border: 1px solid ${theme.colors.neutral.primary[40]};
  `}
`;

export const Lane = styled.div`
  width: 2px;
  height: 100%;
  ${({ theme }) => `
    background: ${theme.colors.secondary[100]};
  `}
`;

export const SmallDot = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 100%;
  ${({ theme }: IThemeProvider) => `
    background: ${theme.colors.secondary[100]};
  `}
`;

export const EmptyDot = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 100%;
  ${({ theme }: IThemeProvider) => `
    border: 2px solid ${theme.colors.secondary[100]};
  `}
`;

export const BigDot = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 100%;
  background-color: #fbcb0c;
  ${({ theme }: IThemeProvider) => `
    border: 1px solid ${theme.colors.secondary[100]};
  `}
`;

export const VariationSignWrapper = styled.div<{ left: number; width: number }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  left: ${({ left }) => left}%;
  width: ${({ width }) => width}%;
  height: 75%;
  ${({ theme }: IThemeProvider) => `
    border-left: 2px solid ${theme.colors.secondary[100]};
    border-right: 2px solid ${theme.colors.secondary[100]};
  `}
`;

export const MiddleLine = styled.div`
  width: 100%;
  height: 2px;
  ${({ theme }: IThemeProvider) => `
    background: ${theme.colors.secondary[100]};
  `}
`;

export const AgreementDot = styled.div`
  width: 15px;
  height: 15px;
  border-radius: 100%;
  ${({ theme }: IThemeProvider) => `
    background: ${theme.colors.neutral.primary[30]};
  `}
`;
